import { createContext } from "react";

export const ChoiceGroupContext = createContext({});
